{
  "actionWithDelay": "Attendre {{seconds}}s, puis {{action}}",
  "areYouSureYouWantToDisconnectTheseDevices": "Êtes-vous sûr de vouloir déconnecter ces appareils ?",
  "changesFrom": "Modifications de :",
  "connectDevices": "Connecter des appareils",
  "newConnection": "Nouvelle connexion",
  "connectedToTitle": "Connecté à:",
  "connectionsWithConnectionCount": "{{connectionCount}} Connexion(s)",
  "connectedToWithDeviceCount": "Connecté à : {{deviceCount}}",
  "connectionsListTitle": "Connexions des appareils",
  "createTitle": "Connexion d'un nouvel appareil",
  "deleteConnection": "Supprimer la connexion",
  "deviceConnectionsListEmpty": "Aucune connexion entre appareils n'a encore été créée. Appuyez sur « Connecter des appareils » pour commencer.",
  "disconnect": "Déconnecter",
  "notificationsDisabled": "Notifications désactivées pour la connexion",
  "notificationsEnabled": "Notifications activées pour la connexion",
  "selectedConnectionTitle": "Connexion de l'appareil",
  "sendANotificationWhen": "Envoyer une notification lorsque...",
  "sendNotificationsToUsers": "Notifications:",
  "source": "Source",
  "target": "Cible",
  "targetDevice": "Appareil cible"
}
